import { Box } from "@mui/system";
import React from "react";
import UserManagementTableTitle from "./UserManagementTableTitle";
import DocumentSearchInput from "./UserManagementSearchInput";
import TextSeparator from "../shared/TextSeparator";
import UserManagementTable from "./table/UserManagementTable";
import UserManagementBatchActions from "./UserManagementBatchActions";
import AddUserDialog from "../dialogs/addUserDialog/AddUserDialog";

type UserManagementTableContainerProps = {};

const UserManagementTableContainer: React.FC<UserManagementTableContainerProps> = () => {
	return (
		<Box
			display="flex"
			flex={1}
			flexDirection="column"
			sx={{
				backgroundColor: "#25293D",
				borderRadius: "8px",
				paddingTop: "20px",
				paddingLeft: "20px",
				paddingRight: "20px",
				paddingBottom: "10px",
				height: "calc(100% - 96px)",
				boxSizing: "border-box",
			}}
		>
			<Box
				display="flex"
				flexDirection="column"
				sx={{
					marginBottom: "5px",
				}}
			>
				<Box
					display="flex"
					flexDirection="row"
					alignItems="center"
					justifyContent="space-between"
					height="38px"
					sx={{
						marginBottom: "5px",
					}}
				>
					<Box display="flex" flexDirection="row" alignItems="center">
						<UserManagementTableTitle />

						<TextSeparator />

						<DocumentSearchInput />
					</Box>

					<UserManagementBatchActions />
				</Box>
			</Box>

			<UserManagementTable />
			<AddUserDialog />
		</Box>
	);
};

export default UserManagementTableContainer;
